/**
 * @file: MediaInfo.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum MediaSourceType {
  Order = 'order',
  Dashboard = 'dashboard',
  Facade = 'facade',
  Inspection = 'inspection',
  CustomIssue = 'custom_issue',
  Diagnostic = 'diagnostic',
  Construction = 'construction',
  DeliveryCheck = 'delivery_check',
}

export interface MediaInfo {
  id: string;
  type: string;
  sourceType: MediaSourceType;
  category: string;
  title?: string;
  subTitle?: string;
  url: string;
  coverUrl?: string;
  dateRef: Date;
  tag?: string;
  remark?: string;
  annotationMetadata?: string;
  sortOrder?: number;
  seqNo?: number;
}
